import {ISelect} from "../component/SelectComponent/SelectNew";

export const radioWave: ISelect[] = [
    {
        value: "Радио Маяк",
        description: "93.6"
    } as ISelect,
    {
        value: "Ретро FM",
        description: "96.4"
    } as ISelect,
    {
        value: "Радио Дача",
        description: "98.7"
    } as ISelect,
    {
        value: "Авторадио",
        description: "99.1"
    } as ISelect,
    {
        value: "Бизнес FM",
        description: "100.8"
    } as ISelect,
    {
        value: "Юмор FM",
        description: "101.2"
    } as ISelect,
    {
        value: "Европа Плюс",
        description: "101.6"
    } as ISelect,
    {
        value: "Русское радио",
        description: "104.1"
    } as ISelect,
    {
        value: "Радио Олимп",
        description: "104.5"
    } as ISelect,
    {
        value: "Радио 7",
        description: "105.4"
    } as ISelect,
    {
        value: "Радио Шансон",
        description: "105.9"
    } as ISelect,
    {
        value: "Дорожное радио",
        description: "106.3"
    } as ISelect,
]
